import React from 'react'
import { Outlet } from 'react-router-dom'

function MainSchedule() {
  return (
    <div>
      <Outlet/>
    </div>
  )
}

export default MainSchedule
